import { isValidTurnstileSiteKey } from 'utils/turnstile';

const turnstileSiteKey = process.env.REACT_APP_TURNSTILE_SITE_KEY || '';

export const config = {
    production: process.env.PRODUCTION || true,
    jwt: {
        secret: process.env.JWT_SECRET || 'EbiTrade',
    },
    api: {
        web: process.env.REACT_APP_API_URL || "https://www.ebitrade.com/api/",
    },
    s3: {
        baseUrl: process.env.REACT_APP_S3_BASE_URL || 'https://obitacora.s3.us-east-1.amazonaws.com/',
    },
    socket: {
        url: process.env.REACT_APP_WS_URL || process.env.ENDPOINT || "wss://www.ebitrade.com",
        // Local http://localhost:5002 must not force TLS
        secure: process.env.REACT_APP_WS_SECURE === 'true'
            || String(process.env.REACT_APP_WS_URL || '').startsWith('https')
            || String(process.env.REACT_APP_WS_URL || '').startsWith('wss'),
        pingInterval: process.env.PING_INTERVAL || 10000,
        pingTimeout: process.env.PING_TIMEOUT || 60000,
        withCredentials: false,
        rejectUnauthorized: false,
        transports: ["websocket", "polling"],
        reconnectionAttempts: "infinity",
        reconnectionDelay: process.env.RECONNECTION_DELAY || 1000,
        reconnectionDelayMax: process.env.RECONNECTION_DELAY_MAX || 5000,
        allowUpgrades: process.env.ALLOW_UPGRADES || false,
        reconnect: true,
        log: process.env.REACT_APP_SOCKET_LOG === 'true',
    },
    chatService: {
        active: false,
        port: process.env.CHAT_SRV_PORT || '',
        path: process.env.PATH_SOCKET || '/ebi_chat',
        channel: process.env.CHAT_SRV_CHANNEL || 'chat',//'api_chat/chat',
    },
    notificationService: {
        active: false,
        port: process.env.CHAT_SRV_PORT || '',
        path: process.env.PATH_SOCKET || '/ebi_notification',
        channel: process.env.CHAT_SRV_CHANNEL || 'notification',//'api_chat/notification',
    },
    // Cotizaciones en vivo (Polygon vía socket). Desactivado por defecto — activar con REACT_APP_TRADE_SOCKET_ACTIVE=true
    tradeService: {
        active: process.env.REACT_APP_TRADE_SOCKET_ACTIVE === 'true',
        port: process.env.REACT_APP_TRADE_WS_PORT || '5002',
        path: process.env.REACT_APP_TRADE_WS_PATH || '/ebi_trade',
        channel: process.env.REACT_APP_TRADE_WS_CHANNEL || 'trade',
    },
    paypal: {
        clientId: process.env.REACT_APP_PAYPAL_CLIENT_ID || '',
        planId: process.env.REACT_APP_PAYPAL_PLAN_ID || '',
        planIdPlusMonthly: process.env.REACT_APP_PAYPAL_PLAN_ID_PLUS_MONTHLY || '',
        planIdPlusAnnual: process.env.REACT_APP_PAYPAL_PLAN_ID_PLUS_ANNUAL || '',
        planIdProMonthly: process.env.REACT_APP_PAYPAL_PLAN_ID_PRO_MONTHLY || '',
        planIdProAnnual: process.env.REACT_APP_PAYPAL_PLAN_ID_PRO_ANNUAL || '',
        sandbox: process.env.REACT_APP_PAYPAL_SANDBOX === 'true',
    },
    turnstile: {
        siteKey: isValidTurnstileSiteKey(turnstileSiteKey) ? turnstileSiteKey.trim() : '',
        enabled: isValidTurnstileSiteKey(turnstileSiteKey),
    },

}
